import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { ExperienceProvider } from '@/components/generals/experience-provider'
import Preloader from '@/components/landing/preloader'
import TopBar from '@/components/landing/top-bar'
import MenuOverlay from '@/components/landing/menu-overlay'
import Ribbons from '@/components/landing/ribbons'
import HeroSection from '@/components/landing/hero-section'
import MembersSection from '@/components/landing/members-section'
import MusicSection from '@/components/landing/music-section'
import JourneySection from '@/components/landing/journey-section'
import VisionSection from '@/components/landing/vision-section'
import SiteFooter from '@/components/landing/site-footer'

const Home: FC = (): ReactNode => {
    return (
        <ExperienceProvider>
            <Seo />

            <a href='#main' className='skip-link'>Skip to content</a>

            <Preloader />
            <TopBar />
            <MenuOverlay />
            <Ribbons />

            <Layout>
                <HeroSection />
                <MembersSection />
                <MusicSection />
                <JourneySection />
                <VisionSection />
            </Layout>

            <SiteFooter />

            <div className='grain' aria-hidden='true' />
        </ExperienceProvider>
    )
}

export default Home
